export default "__VITE_ASSET__Bo_GuY4e__"